export default {
    baseStyle: {
        wrapper: {
            bg: 'gray.150',
            position: 'sticky',
            top: '0',
            borderBottom: '1px',
            borderColor: 'gray.100'
        },
        container: {
            maxWidth: '1016px',
            width: '100%',
            padding: {
                base: '0px 24px 0px 24px',
                md: '0px 30px 0px 30px',
                lg: '0px 40px 0px 40px'
            },
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        stack: {
            height: {base: '52px', md: '75px'},
            align: 'center',
            justify: 'space-between'
        },
        button: {
            display: {base: 'inline-flex', md: 'none'},
            fontSize: {base: '11px', md: '12px'},
            variant: 'unstyled',
            color: 'gray.900',
            textTransform: 'uppercase',
            marginLeft: {base: '1.5rem', md: '0px'}
        },
        confirmbutton: {
            display: 'inline-flex',
            fontSize: {base: '11px', md: '13px'},
            variant: 'unstyled',
            color: 'gray.900',
            fontWeight: {base: '600', md: '400'},
            textTransform: 'uppercase',
            marginLeft: {base: '1.5rem', md: '0px'},
            textDecoration: 'none!important',
            link: {
                textDecoration: 'none!important'
            }
        },
        icon: {
            wrapper: {
                position: 'relative',
                width: {base: '20px', md: '24px'},
                height: {base: '20px', md: '24px'},
                marginInlineStart: {base: '-8px', md: '-6px'}
            },
            right: {
                position: 'absolute',
                left: '0px'
            }
        },
        mainLogo: {
            width: {base: '48%', md: 'auto'}
        }
    }
}
